// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { SaaSCompanyKpiTemplateFields, TemplateType } from 'common/report/dashboards/types';
import { Translatable } from 'common/i18n';
export enum RHSPanelMode {
  StarterBoard = "starter-board",
  Templates = "templates",
}
export interface RHSPanelState {
  fields: { [key in TemplateField]?: any } | EmptyObj;
  calendarInputOpen?: boolean;
  tutorialCurrentStepIndex: number;
  showTutorial: boolean;
  hideTutorial: boolean;
}
export interface RHSPanelProps {
  params?: RHSPanelParams;
  on?: {
    updateBlueprint?: (ev: CustomEvent<any>) => void;
    commitBlueprint?: (ev: CustomEvent<any>) => void;
    clickSeeAllTemplates?: (ev: CustomEvent<any>) => void;
  };
}
export interface RHSPanelParams {
  mode: RHSPanelMode;
  selectedTemplate?: TemplateType;
  isLoading?: boolean;
  isSeeAllTemplatesLoading?: boolean;
  showReminderTooltip?: boolean;
}
export type MoreInfoConfig = {
  text: string;
  link: string;
};
export enum RHSInputType {
  Event = "event",
  Property = "property",
  Date = "date",
  List = "list",
  Key = "key",
  Text = "text",
}
export type TemplateCard = {
  title: string;
  templateSelectDescription: string;
  imageId: string;
  eventSelectStepDescription: string;
  requiredFieldsCheck: () => boolean;
  demoBoardLink?: string;
  moreInfo?: MoreInfoConfig;
};
export type TemplateField = KPITemplateFields | ProductLaunchTemplateFields | LifecycleCohortAnalysisTemplateFields | MarketingKPITemplateFields | ECommerceTemplateFields | WebAnalyticsTemplateFields | BenchmarkKPITemplateFields | SaaSCompanyKpiTemplateFields;
export enum KPITemplateFields {
  SIGN_UP = "Sign Up",
  VALUE_MOMENT = "Value Moment",
}
export enum BenchmarkKPITemplateFields {
  SIGN_UP = "Sign Up",
  VALUE_MOMENT = "Value Moment",
  INDUSTRY = "Industry",
}
export enum ProductLaunchTemplateFields {
  FEATURE_NAME = "Feature Name",
  LAUNCH_DATE = "Launch Date",
  NEW_FEATURE = "New Feature",
  FEATURE_VALUE_MOMENT = "Feature Value Moment",
}
export enum LifecycleCohortAnalysisTemplateFields {
  VALUE_MOMENT = "Value Moment",
}
export enum MarketingKPITemplateFields {
  ACTIVATION_EVENT = "Activation Event",
  CONVERSION_EVENT = "Conversion Event",
}
export enum ECommerceTemplateFields {
  SIGN_UP_EVENT = "EComm Sign Up",
  PURCHASE_EVENT = "Purchase",
  ADD_TO_CART_EVENT = "Add to Cart",
  PRODUCT_VIEWED_EVENT = "Product Viewed",
  CART_PROPERTY = "Cart Property",
  CART_PROPERTY_2 = "Cart Property 2",
  PRICE_KEY = "Price Key",
  CATEGORY_KEY = "Category Key",
  AD_SPEND_EVENT = "Ad Spend Event",
  AD_COST_PROPERTY = "Ad Cost",
}
export enum WebAnalyticsTemplateFields {
  PAGE_LOADED_EVENT = "Page Loaded",
  PAGE_NAME_PROPERTY = "Page Name",
}
export const TemplateFieldLabelTranslation = {
  [KPITemplateFields.SIGN_UP]: _ref => {
    let {
      t
    } = _ref;
    return t("boards.rhs.kpi.label.sign-up");
  },
  [KPITemplateFields.VALUE_MOMENT]: _ref2 => {
    let {
      t
    } = _ref2;
    return t("boards.rhs.kpi.label.value-moment");
  },
  [BenchmarkKPITemplateFields.INDUSTRY]: _ref3 => {
    let {
      t
    } = _ref3;
    return t("boards.rhs.benchmark.label.industry");
  },
  [ProductLaunchTemplateFields.FEATURE_NAME]: _ref4 => {
    let {
      t
    } = _ref4;
    return t("boards.rhs.product-launch.label.feature-name");
  },
  [ProductLaunchTemplateFields.LAUNCH_DATE]: _ref5 => {
    let {
      t
    } = _ref5;
    return t("boards.rhs.product-launch.label.launch-date");
  },
  [ProductLaunchTemplateFields.NEW_FEATURE]: _ref6 => {
    let {
      t
    } = _ref6;
    return t("boards.rhs.product-launch.label.new-feature");
  },
  [ProductLaunchTemplateFields.FEATURE_VALUE_MOMENT]: _ref7 => {
    let {
      t
    } = _ref7;
    return t("boards.rhs.product-launch.label.feature-value-moment");
  },
  [MarketingKPITemplateFields.ACTIVATION_EVENT]: _ref8 => {
    let {
      t
    } = _ref8;
    return t("boards.rhs.marketing-kpi.label.activation");
  },
  [MarketingKPITemplateFields.CONVERSION_EVENT]: _ref9 => {
    let {
      t
    } = _ref9;
    return t("boards.rhs.marketing-kpi.label.conversion");
  },
  [ECommerceTemplateFields.PURCHASE_EVENT]: _ref10 => {
    let {
      t
    } = _ref10;
    return t("boards.rhs.ecommerce.label.purchase");
  },
  [ECommerceTemplateFields.ADD_TO_CART_EVENT]: _ref11 => {
    let {
      t
    } = _ref11;
    return t("boards.rhs.ecommerce.label.add-to-cart");
  },
  [ECommerceTemplateFields.PRODUCT_VIEWED_EVENT]: _ref12 => {
    let {
      t
    } = _ref12;
    return t("boards.rhs.ecommerce.label.product-viewed");
  },
  [ECommerceTemplateFields.CART_PROPERTY]: _ref13 => {
    let {
      t
    } = _ref13;
    return t("boards.rhs.ecommerce.label.cart");
  },
  [ECommerceTemplateFields.CART_PROPERTY_2]: _ref14 => {
    let {
      t
    } = _ref14;
    return t("boards.rhs.ecommerce.label.cart");
  },
  [ECommerceTemplateFields.PRICE_KEY]: _ref15 => {
    let {
      t
    } = _ref15;
    return t("boards.rhs.ecommerce.label.price");
  },
  [ECommerceTemplateFields.CATEGORY_KEY]: _ref16 => {
    let {
      t
    } = _ref16;
    return t("boards.rhs.ecommerce.label.category");
  },
  [ECommerceTemplateFields.SIGN_UP_EVENT]: _ref17 => {
    let {
      t
    } = _ref17;
    return t("boards.rhs.ecommerce.label.sign-up");
  },
  [ECommerceTemplateFields.AD_SPEND_EVENT]: _ref18 => {
    let {
      t
    } = _ref18;
    return t("boards.rhs.ecommerce.label.ad-spend");
  },
  [ECommerceTemplateFields.AD_COST_PROPERTY]: _ref19 => {
    let {
      t
    } = _ref19;
    return t("boards.rhs.ecommerce.label.ad-cost-property");
  },
  [WebAnalyticsTemplateFields.PAGE_LOADED_EVENT]: _ref20 => {
    let {
      t
    } = _ref20;
    return t("boards.rhs.web-analytics.label.page-loaded");
  },
  [WebAnalyticsTemplateFields.PAGE_NAME_PROPERTY]: _ref21 => {
    let {
      t
    } = _ref21;
    return t("boards.rhs.web-analytics.label.page-name");
  },
  [SaaSCompanyKpiTemplateFields.MRR_PROPERTY_FIELD]: _ref22 => {
    let {
      t
    } = _ref22;
    return t("boards.rhs.saas-company-kpi.label.mrr");
  },
  [SaaSCompanyKpiTemplateFields.SEGMENT_PROPERTY_FIELD]: _ref23 => {
    let {
      t
    } = _ref23;
    return t("boards.rhs.saas-company-kpi.label.segment");
  },
  [SaaSCompanyKpiTemplateFields.PLAN_TYPE_PROPERTY_FIELD]: _ref24 => {
    let {
      t
    } = _ref24;
    return t("boards.rhs.saas-company-kpi.label.plan-type");
  }
};
export type TutorialStep = {
  nextStepIndex?: number;
  stepInfo: Translatable;
};
export type TUTORIAL_FINISHED = `Tutorial Finished`;
export type TutorialConfig = { [key in TemplateField | TUTORIAL_FINISHED]?: TutorialStep };
export const ECOMMERCE_TUTORIAL_CONFIG: TutorialConfig = {
  [ECommerceTemplateFields.SIGN_UP_EVENT]: {
    nextStepIndex: 1,
    stepInfo: _ref25 => {
      let {
        t
      } = _ref25;
      return t("boards.rhs.ecommerce.tutorial.sign-up");
    }
  },
  [ECommerceTemplateFields.PURCHASE_EVENT]: {
    nextStepIndex: 2,
    stepInfo: _ref26 => {
      let {
        t
      } = _ref26;
      return t("boards.rhs.ecommerce.tutorial.purchase");
    }
  },
  [ECommerceTemplateFields.CART_PROPERTY]: {
    nextStepIndex: 3,
    stepInfo: _ref27 => {
      let {
        t
      } = _ref27;
      return t("boards.rhs.ecommerce.tutorial.cart");
    }
  },
  [ECommerceTemplateFields.PRICE_KEY]: {
    nextStepIndex: 4,
    stepInfo: _ref28 => {
      let {
        t
      } = _ref28;
      return t("boards.rhs.ecommerce.tutorial.price");
    }
  },
  [ECommerceTemplateFields.ADD_TO_CART_EVENT]: {
    nextStepIndex: 5,
    stepInfo: _ref29 => {
      let {
        t
      } = _ref29;
      return t("boards.rhs.ecommerce.tutorial.add-to-cart");
    }
  },
  [ECommerceTemplateFields.CART_PROPERTY_2]: {
    nextStepIndex: 6,
    stepInfo: _ref30 => {
      let {
        t
      } = _ref30;
      return t("boards.rhs.ecommerce.tutorial.cart");
    }
  },
  [ECommerceTemplateFields.CATEGORY_KEY]: {
    nextStepIndex: 7,
    stepInfo: _ref31 => {
      let {
        t
      } = _ref31;
      return t("boards.rhs.ecommerce.tutorial.category");
    }
  },
  [ECommerceTemplateFields.PRODUCT_VIEWED_EVENT]: {
    nextStepIndex: 8,
    stepInfo: _ref32 => {
      let {
        t
      } = _ref32;
      return t("boards.rhs.ecommerce.tutorial.product-viewed");
    }
  },
  [ECommerceTemplateFields.AD_SPEND_EVENT]: {
    nextStepIndex: 9,
    stepInfo: _ref33 => {
      let {
        t
      } = _ref33;
      return t("boards.rhs.ecommerce.tutorial.ad-spend");
    }
  },
  [ECommerceTemplateFields.AD_COST_PROPERTY]: {
    stepInfo: _ref34 => {
      let {
        t
      } = _ref34;
      return t("boards.rhs.ecommerce.tutorial.ad-cost");
    },
    nextStepIndex: 10
  },
  'Tutorial Finished': {
    stepInfo: _ref35 => {
      let {
        t
      } = _ref35;
      return t("boards.rhs.ecommerce.tutorial.finished");
    }
  }
};
export const ADVANCED_TEMPLATE_TYPES_TO_TUTORIAL_MAP: Map<TemplateType, TutorialConfig> = new Map([[TemplateType.E_COMMERCE, ECOMMERCE_TUTORIAL_CONFIG]]); // add more advanced template types here

export const LEARN_MORE_LINK_MAP: Map<TemplateType, string> = new Map([[TemplateType.E_COMMERCE, "https://mixpanel.com/blog/mixpanel-ecommerce-analytics/"]]); // add more advanced template types here